'use client';

import { useCartRewardProductsPrefetch, useCartService, useRegionCurrency, useUser } from '@skin-seoul/service';
import { usePersonalizationTracker } from '@skin-seoul/utils';

/** Keep reward products ready while the cart drawer is closed. */
export function CartRewardProductsPrefetch() {
  const { country, currency } = useRegionCurrency();
  const actorId = usePersonalizationTracker().getActorId() ?? undefined;
  const { useGetCartQuery } = useCartService();
  const cartQuery = useGetCartQuery({ currency });
  const { user, isLoading: isUserLoading } = useUser();
  useCartRewardProductsPrefetch({
    cart: cartQuery.data?.cart,
    isAuthenticated: cartQuery.data?.isAuthenticated,
    isCartError: cartQuery.isError,
    cartUpdatedAt: cartQuery.dataUpdatedAt,
    currency,
    country,
    actorId,
    customerId: user?.userId ?? null,
    isUserLoading,
  });
  return null;
}
